export default {
  title: 'Åbningstider og lokation',
  set_different_opening_hours: 'Angiv andre åbningstider for levering',
  delivery_opening_hours: 'Åbningstider for levering',
  sections: {
    general: 'Generelle åbningstider',
    holidays: 'Sæt ordrer på pause (ferie)',
    create_time: 'Tilføj åbningstid',
    edit_time: 'Rediger tid',
    delivery_schedule: 'Åbningstider for levering',
  },
  tabs: {
    open_times: 'Åbningstider',
    location: 'Placering',
  },
  form: {
    select_all: {
      label: 'Vælg alle dage',
    },
    holiday_starts_at: {
      label: 'Startdato',
    },
    holiday_ends_at: {
      label: 'Slutdato',
    },
    has_delivery_schedule: {
      label: 'Angiv andre åbningstider for levering',
    },
    has_multiple_locations: {
      label: 'Angiv forskellige placeringer for ugen',
    },
  },
  labels: {
    day_location: '{{day}} placering {{index}}',
    selected_days: 'Valgte dage',
    orders_paused: 'Bestillinger sat på pause',
    open_time: 'Åbningstid',
    close_time: 'Lukketid',
  },
  errors: {
    close_time: 'Lukketiden kan ikke være 00:00. Indtast 23:59',
  },
  buttons: {
    edit: 'Rediger',
    add_schedule_unit: 'Tilføj åbningstid',
    add_holiday: 'Tilføj helligdag',
    delete: 'Slet',
    save: 'Gem',
    cancel: 'Annuller',
  },
  toasts: {
    changes_got_saved: 'Oplysningerne er opdateret',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
  },
};
